import {
	hasInternetConnection,
	loadFromLocalStorage,
	loadFromSessionStorage,
	saveToLocalStorage,
	saveToSessionStorage,
} from "./systemService";
import { userSettingsKeys } from "../configs/storageKeys.json";
import {
	getConsent,
	getPID,
	getSettings,
	setPID,
	setSettings,
} from "./dashApiService";
import { toast } from "react-toastify";
import { getNowInEpochTime } from "./dateService";
import { toastConfig } from "../configs/toastConfig";

let userSettings = null;
let userPid = null;
let companionStartDate = null;
let appSettings = null;

function getDiseaseGroup() {
	const diseaseGroup = loadFromLocalStorage(userSettingsKeys.diseaseGroup);

	return diseaseGroup;
}

function setDiseaseGroup(diseaseGroup) {
	saveToLocalStorage(userSettingsKeys.diseaseGroup, diseaseGroup);
}

function getDiseaseName() {
	const diseaseGroup = getDiseaseGroup();
	switch (diseaseGroup) {
		case "lcn":
			return "Lung Cancer";
		case "meso":
		case "mesoperitoneal":
			return "Mesothelioma";
		default:
			return "your condition";
	}
}

function getDiseaseGroupCompany(abbreviate) {
	const diseaseGroup = getDiseaseGroup();
	switch (diseaseGroup) {
		case "lcn":
			return abbreviate ? "LCNUK" : "Lung Cancer Nursing UK";
		case "meso":
		case "mesoperitoneal":
			return abbreviate ? "Meso" : "Mesothelioma UK";
		default:
			return "Dash Global";
	}
}

function getUserSettings() {
	if (userSettings) {
	} else {
		userSettings = loadUserSettingsFromStorage();

		if (userSettings) {
		} else {
			userSettings = {
				complete: false,
			};
		}
	}
	initialiseUserSettings(userSettings);

	return userSettings;
}

function getAppSettings() {
	if (!appSettings) {
		appSettings = loadFromSessionStorage("appSettings") || "{}";
	}

	return appSettings;
}

function getUserPid() {
	if (userPid) {
	} else {
		userPid = loadUserPidFromStorage();
	}

	return userPid;
}

function getCompanionStartDate() {
	if (companionStartDate) {
	} else {
		companionStartDate = loadCompanionStartDateFromStorage();
	}

	return companionStartDate;
}

function getSettingsComplete() {
	const settings = getUserSettings();

	const props = Object.entries(settings);

	let propCount = 0;
	let completeCount = 0;

	for (const [key, value] of props) {
		if (key === "complete") {
			continue;
		}

		++propCount;

		if (value.complete === true) {
			++completeCount;
		}
	}

	const percentage = (completeCount / propCount) * 100;

	return Math.floor(percentage);
}

function setIntroductionComplete() {
	return new Promise((resolve) => {
		userSettings.introduction = userSettings.introduction || {};
		userSettings.introduction.complete = true;
		saveUserSettings()
			.then(resolve)
			.catch(() => {
				userSettings.introduction.complete = false;
				resolve();
			});
	});
}

function saveYourControl(options, sendRequest) {
	if (sendRequest === false) {
		userSettings.yourControl = options;
	} else {
		return new Promise((resolve) => {
			userSettings.yourControl = options;

			saveUserSettings()
				.then(resolve)
				.catch(() => {
					userSettings.yourControl.complete = false;
					resolve();
				});
		});
	}
}

function saveYourDetails(options) {
	return new Promise((resolve) => {
		userSettings.yourDetails = options;
		saveUserSettings()
			.then(resolve)
			.catch(() => {
				userSettings.yourDetails.complete = false;
				resolve();
			});
	});
}

function saveConsent(options) {
	return new Promise((resolve) => {
		userSettings.consent = options;

		saveUserSettings()
			.then(resolve)
			.catch(() => {
				userSettings.consent.complete = false;
				resolve();
			});
	});
}

function saveSmokingHistory(options) {
	return new Promise((resolve) => {
		userSettings.smokingHistory = options;
		saveUserSettings()
			.then(resolve)
			.catch(() => {
				userSettings.smokingHistory.complete = false;
				resolve();
			});
	});
}

function saveInitialExperience(options) {
	return new Promise((resolve) => {
		userSettings.initialExperience = options;
		saveUserSettings()
			.then(resolve)
			.catch(() => {
				userSettings.initialExperience.complete = false;
				resolve();
			});
	});
}

function saveAsbestosHistory(options) {
	return new Promise((resolve) => {
		userSettings.asbestosHistory = options;
		saveUserSettings()
			.then(resolve)
			.catch(() => {
				userSettings.asbestosHistory.complete = false;
				resolve();
			});
	});
}

function saveBenefitStatus(options) {
	return new Promise((resolve) => {
		userSettings.benefitStatus = options;
		saveUserSettings()
			.then(resolve)
			.catch(() => {
				userSettings.benefitStatus.complete = false;
				resolve();
			});
	});
}

function saveLongTermConditions(options) {
	return new Promise((resolve) => {
		userSettings.longTermConditions = options;
		saveUserSettings()
			.then(resolve)
			.catch(() => {
				userSettings.longTermConditions.complete = false;
				resolve();
			});
	});
}

function saveCompensation(options) {
	return new Promise((resolve) => {
		userSettings.compensation = options;
		saveUserSettings()
			.then(resolve)
			.catch(() => {
				userSettings.compensation.complete = false;
				resolve();
			});
	});
}

function initialiseUserSettings(settings) {
	if (settings.introduction) {
	} else {
		settings.introduction = { complete: false };
	}

	if (settings.yourControl) {
	} else {
		settings.yourControl = createYourControl();
	}

	if (settings.consent) {
	} else {
		settings.consent = createConsent();
	}

	if (settings.yourDetails) {
	} else {
		settings.yourDetails = createYourDetails();
	}

	if (settings.smokingHistory) {
	} else {
		settings.smokingHistory = createSmokingHistory();
	}

	if (settings.asbestosHistory) {
	} else {
		settings.asbestosHistory = createAsbestosHistory();
	}

	// if (settings.initialExperience) {
	// } else {
	// 	settings.initialExperience = createInitialExperience();
	// }

	if (settings.benefitStatus) {
	} else {
		settings.benefitStatus = createBenefitStatus();
	}

	if (settings.longTermConditions) {
	} else {
		settings.longTermConditions = createLongTermConditions();
	}

	if (settings.compensation) {
	} else {
		settings.compensation = createCompensation();
	}

	userSettings = settings;
}

function saveUserSettings() {
	return new Promise((resolve, reject) => {
		setSettings(userSettings)
			.then((response) => {
				if (response.success) {
					saveUserSettingsToStorage(userSettings);
					resolve(response);
				} else {
					toast.error(
						<>
							<p className="mb-1">There was an error saving your settings.</p>
							<p className="mb-1">
								Please make sure that you have a good connection to the internet
								and try again.
							</p>
							<p>
								If the problem persists, please contact our helpdesk, quoting
								reference '#SU001'.
							</p>
						</>,
						{
							toastId: toastConfig.toastIds.errSave,
						}
					);

					reject();
				}
			})
			.catch((error) => {
				toast.error(
					<>
						<p className="mb-1">There was an error saving your settings.</p>
						<p className="mb-1">
							Please make sure that you have a good connection to the internet
							and try again.
						</p>
						<p>
							If the problem persists, please contact our helpdesk, quoting
							reference '#SU002'.
						</p>
					</>,
					{
						toastId: toastConfig.toastIds.errNetwork,
					}
				);
				reject();
			});
	});
}

function saveUserPid(pid) {
	userPid = pid;
	return new Promise((resolve, reject) => {
		setPID(pid)
			.then((response) => {
				if (response.success) {
					saveUserPidToStorage(pid);
					resolve(response);
				} else {
					toast.error(
						<>
							<p className="mb-1">There was an error saving your settings.</p>
							<p className="mb-1">
								Please make sure that you have a good connection to the internet
								and try again.
							</p>
							<p>
								If the problem persists, please contact our helpdesk, quoting
								reference '#SU003'.
							</p>
						</>,
						{
							toastId: toastConfig.toastIds.errSave,
						}
					);
					reject(response);
				}
			})
			.catch((error) => {
				toast.error(
					<>
						<p className="mb-1">There was an error saving your settings.</p>
						<p className="mb-1">
							Please make sure that you have a good connection to the internet
							and try again.
						</p>
						<p>
							If the problem persists, please contact our helpdesk, quoting
							reference '#SU004'.
						</p>
					</>,
					{
						toastId: toastConfig.toastIds.errNetwork,
					}
				);
				reject(error);
			});
	});
}

function createInitialExperience() {
	return {
		complete: false,
		recallFirstSymptoms: null,
		symptomsMonth: null,
		symptomsYear: null,
		recallFirstDiagnosis: null,
		diagnosisMonth: null,
		diagnosisYear: null,
		gpSymptoms: null,
		firstDiagnosis: null,
		diagnosisExplanation: null,
		sensitiveExplanation: null,
		multiDisciplinaryReview: null,
	};
}

function createSmokingHistory() {
	return {
		complete: false,
		smoker: null,
		smokingDuration: null,
		smokingTypes: [],
		cigaretteAmount: null,
	};
}

function createYourDetails() {
	return {
		complete: false,
		ethnicity: null,
		height: {
			feet: null,
			inches: null,
			cm: null,
		},
		weight: {
			stone: null,
			pounds: null,
			kg: null,
		},
	};
}

function createYourControl() {
	return {
		complete: false,
		dayOfWeek: null,
		experienceOffset: null, //int as enum
		keepExpensesDiary: null, //bool
		reminders: null,
	};
}

function createConsent() {
	return {
		complete: false,
		consent: null, //bool
		consentAccepted: null, //date
	};
}

function createAsbestosHistory() {
	return {
		complete: false,
		asbestosExposure: null,
		occupationHistory: [],
		armedForcesType: null,
		lengthOfService: null,
		helpIdentify: null,
	};
}

function createBenefitStatus() {
	return {
		complete: false,
		benefitAdvice: [],
		receivingBenefits: null,
		whichBenefits: [],
	};
}

function createLongTermConditions() {
	return {
		complete: false,
		conditions: [],
		otherText: "",
	};
}

function createCompensation() {
	return {
		haveReceived: null,
		whyNot: null,
		whereFrom: [],
		claimSuccess: null,
		lawFirm: "",
		employer: "",
		totalCompensation: "",
	};
}

function isDemoUser() {
	let val = loadFromSessionStorage("isDemoUser") || "false";
	val = val.toLowerCase() === "true" ? true : false;
	return val;
}

function setIsDemoUser(value) {
	saveToSessionStorage("isDemoUser", value);
}

function setIsLoggedIn(value) {
	saveToSessionStorage("isLoggedIn", value.toString());
}

function getIsLoggedIn() {
	let val = loadFromSessionStorage("isLoggedIn") || "false";
	val = val.toLowerCase() === "true" ? true : false;

	return val;
}

function isRegistrar() {
	let val = loadFromSessionStorage("isRegistrar") || "false";
	val = val.toLowerCase() === "true" ? true : false;
	return val;
}

function setIsRegistrar(value) {
	saveToSessionStorage("isRegistrar", value);
}

function setAppSettings(value) {
	saveToSessionStorage("appSettings", value);
}

function loadUserSettings() {
	return new Promise((resolve, reject) => {
		let consent;

		if (hasInternetConnection) {
			getConsent()
				.then((consentResponse) => {
					if (consentResponse.success === true) {
						companionStartDate = parseInt(
							consentResponse.data.consentConfirmed
						);
						saveCompanionStartDateToStorage(companionStartDate);

						for (const f of [
							"companionConsent",
							"consentConfirmed",
							"dataConsentGiven",
							"dataConsentWithheld",
							"participationConsent",
						]) {
							if (consentResponse.data[f]) {
								consentResponse.data[f] = parseInt(consentResponse.data[f], 10);
							}
						}
						consent = consentResponse.data;
					} else {
						companionStartDate =
							loadCompanionStartDateFromStorage() ?? getNowInEpochTime();
					}
				})
				.catch((error) => {
					console.error(error);
					companionStartDate =
						loadCompanionStartDateFromStorage() ?? getNowInEpochTime();
				})
				.finally(() => {
					getSettings()
						.then((data) => {
							if (data.success === true) {
								userSettings = data.data.settings;
								const defConsent = {
									consentAccepted: consent.dataConsentStatus
										? consent.dataConsentGiven
										: null,
									consent: consent.dataConsentStatus,
								};
								userSettings.consent = userSettings.consent || defConsent;

								saveUserSettingsToStorage(data.data.settings);

								resolve(userSettings);
							} else {
								userSettings = loadUserSettingsFromStorage();
								resolve(userSettings);
							}
						})
						.catch((error) => {
							console.error(error);
							userSettings = loadUserSettingsFromStorage();
							reject(error);
						});
				});
		} else {
			userSettings = loadUserSettingsFromStorage();
			resolve(userSettings);
		}
	});
}

function loadUserPid() {
	return new Promise((resolve, reject) => {
		if (hasInternetConnection) {
			getPID()
				.then((response) => {
					if (response.success) {
						userPid = response.data;
						saveUserPidToStorage(userPid);
					}

					resolve(response);
				})
				.catch((error) => {
					console.error(error);
					userPid = loadUserPidFromStorage();

					reject(error);
				});
		} else {
			userPid = loadUserPidFromStorage();
			resolve({ success: true, data: userPid });
		}
	});
}

function saveUserSettingsToStorage(settings) {
	saveToLocalStorage(userSettingsKeys.settings, settings);
}

function saveCompanionStartDateToStorage(startDate) {
	saveToLocalStorage(userSettingsKeys.startDate, startDate);
}

function saveUserPidToStorage(pid) {
	saveToLocalStorage(userSettingsKeys.pid, pid);
}

function loadUserSettingsFromStorage() {
	const settings = loadFromLocalStorage(userSettingsKeys.settings);
	if (settings) {
		return settings;
	}

	return null;
}

function loadCompanionStartDateFromStorage() {
	const startDate = loadFromLocalStorage(userSettingsKeys.startDate);
	if (startDate) {
		return startDate;
	}

	return null;
}

function loadUserPidFromStorage() {
	const pid = loadFromLocalStorage(userSettingsKeys.pid);
	if (pid) {
		return pid;
	}
	return null;
}

function resetUserSettings() {
	userSettings = loadUserSettingsFromStorage();
}

function resetUserPid() {
	userPid = loadUserPidFromStorage();
}

export {
	getDiseaseGroup,
	getIsLoggedIn,
	getUserSettings,
	getUserPid,
	getCompanionStartDate,
	getDiseaseName,
	getDiseaseGroupCompany,
	getAppSettings,
	createYourControl,
	createConsent,
	createYourDetails,
	createSmokingHistory,
	createInitialExperience,
	createAsbestosHistory,
	createBenefitStatus,
	createCompensation,
	isDemoUser,
	setIsDemoUser,
	isRegistrar,
	setAppSettings,
	setDiseaseGroup,
	setIsLoggedIn,
	setIsRegistrar,
	setIntroductionComplete,
	saveYourControl,
	saveConsent,
	saveYourDetails,
	saveSmokingHistory,
	saveInitialExperience,
	saveAsbestosHistory,
	saveBenefitStatus,
	saveLongTermConditions,
	saveCompensation,
	saveUserPid,
	loadUserPid,
	loadUserSettings,
	getSettingsComplete,
	resetUserSettings,
	resetUserPid,
};
